import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchCompanyDetails } from "../../utils/apiCalls";
import Loader from "../../shared/Loader";
import { useSelector } from "react-redux";

const CompanyListTable = () => {
    const navigate = useNavigate();
    const userType = localStorage.getItem("userType");
    const MerchantId = localStorage.getItem("MerchantId");
    const { selectedMerchant: reduxSelectedMerchant } = useSelector((state) => state.merchant || {});
    const selectedMerchant = userType === "merchant" ? MerchantId : reduxSelectedMerchant;

    const [isLoading, setIsLoading] = useState(false);
    const [companies, setCompanies] = useState([]);
    const [displayedCompanies, setDisplayedCompanies] = useState([]);

    // Fetch branches from the API
    const fetchDataAndSetRows = useCallback(async () => {
        setIsLoading(true);
        try {
            const response = await fetchCompanyDetails();
            setCompanies(response?.data || []);
        } catch (error) {
            console.error("Error fetching company details:", error);
        } finally {
            setIsLoading(false);
        }
    }, []);

    // Fetch branches on component mount
    useEffect(() => {
        fetchDataAndSetRows();
    }, [fetchDataAndSetRows]);

    useEffect(() => {
        if (selectedMerchant && selectedMerchant !== "all") {
            const filteredCompanies = companies?.filter(company => company?.merchantId == selectedMerchant);
            setDisplayedCompanies(filteredCompanies);
        } else {
            setDisplayedCompanies(companies);
        }
    }, [selectedMerchant, companies]);

    // Handle edit button click
    const handleEditClick = (company) => {
        navigate(`/settings/editCompanyConfiguration/${company.id}`);
    };

    // Styles for table headers and cells
    const tableHeaderStyle = {
        padding: "10px",
        textAlign: "left",
        background: "#f2f2f2",
        borderBottom: "1px solid #dee2e6",
    };

    const tableCellStyle = {
        padding: "10px",
        textAlign: "left",
    };

    return (
        <>
            {isLoading ? (
                <Loader />
            ) : (
                <div>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                        <thead style={{ borderBottom: "2px solid #dee2e6" }}>
                            <tr>
                                <th style={tableHeaderStyle}>ID</th>
                                <th style={tableHeaderStyle}>Name</th>
                                <th style={tableHeaderStyle}>Email</th>
                                <th style={tableHeaderStyle}>Vat Number</th>
                                <th style={tableHeaderStyle}>Tax Name</th>
                                <th style={tableHeaderStyle}>Tax %</th>
                                <th style={{ ...tableHeaderStyle, textAlign: "center" }}>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {displayedCompanies.length > 0 ? (displayedCompanies.map((company) => (
                                <tr key={company.id} style={{ borderBottom: "1px solid #dee2e6" }}>
                                    <td style={tableCellStyle}>{company?.id}</td>
                                    <td style={tableCellStyle}>{company?.name}</td>
                                    <td style={tableCellStyle}>{company?.email}</td>
                                    <td style={tableCellStyle}>{company?.vatNumber}</td>
                                    <td style={tableCellStyle}>{company?.taxName}</td>
                                    <td style={tableCellStyle}>{company?.taxPercentage}</td>
                                    <td style={tableCellStyle}>
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                            }}
                                        >
                                            <i
                                                className="fa fa-pencil"
                                                style={{
                                                    width: 35,
                                                    fontSize: 20,
                                                    padding: 11,
                                                    cursor: "pointer",
                                                    color: "rgb(40, 167, 69)",
                                                }}
                                                onClick={() => handleEditClick(company)}
                                            ></i>
                                        </div>
                                    </td>
                                </tr>
                            ))) : (
                                <tr>
                                    <td colSpan="7" style={{ textAlign: "center", padding: "20px" }}>
                                        No record found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            )}
        </>
    );
};

export default CompanyListTable;
